<template>
	<div>
		<v-card rounded class='mb-10'>
			<v-card-text v-html='text' />
		</v-card>

		<MediaTabs :items="mediaGroups" />
	</div>
</template>

<script>
import ContentService from '@/services/ContentService'
import MediaTabs from '@/components/n-collections/MediaTabs'

export default {
	components: {
		MediaTabs,
	},

	metaInfo: {
    title: 'Media'
  },

	data() {
		return {
			text: '',
			mediaGroups: [],
		}
	},

	async created() {
		const { text, items } = await ContentService.get('media')
		this.text = text
		this.mediaGroups = items
	},
}
</script>